import Icon from '../Icon';
import React, { useState } from 'react';
import PriceHistoryModal from './PriceHistoryModal';
import PriceModal from '../../Types/PriceModal';

const PriceHistoryModalTrigger = (productPriceHistory: PriceModal) => {
  const [modalOpen, setModalOpen] = useState(false);

  const onClick = () => {
    setModalOpen(true);
  };

  return (
    <>
      <button onClick={onClick}>
        <Icon name="info" className="h-5 w-5" />
      </button>
      {modalOpen && (
        <PriceHistoryModal
          content={productPriceHistory}
          open={modalOpen}
          close={() => setModalOpen(false)}
        />
      )}
    </>
  );
};
export default PriceHistoryModalTrigger;
